/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
import React, { useState } from 'react'
import LockSvgIcon from '../assets/svg/LockSvgIcon'
import ayeIcon from '../assets/aye.png'
import InputAdornmentSVGWrapper from '../common/InputAdornmentSVGWrapper'

interface Props {
  id: string
  value: string
  label: string
  onChange: TextFieldProps['onChange']
  onBlur: TextFieldProps['onBlur']
  error?: boolean
  helperText?: string
}

function FormFieldPassword(props: Props) {
  const { onChange, label, value, error, helperText, onBlur, id } = props
  const [type, setType] = useState('password')

  const handlePressAye = () => {
    if (type === 'password') setType('text')
    else setType('password')
  }

  return (
    <TextField
      required
      id={id}
      type={type}
      label={label}
      variant="outlined"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <InputAdornmentSVGWrapper>
              <LockSvgIcon />
            </InputAdornmentSVGWrapper>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <div
              onClick={handlePressAye}
              css={css`
                position: absolute;
                right: 30px;
                top: 50%;
                margin-top: -8px;
                cursor: pointer;
              `}
            >
              <img
                src={ayeIcon}
                css={css`
                  width: 25px;
                  height: 17px;
                `}
                alt={'show'}
              />
            </div>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default FormFieldPassword
